var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 250 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_43);}.cls-2{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_43-2);}.cls-3{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_43-3);}.cls-4{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_43-4);}.cls-5{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_43-5);}.cls-6{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_43-6);}.cls-7{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_43-7);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_43",
    x1: 92.23,
    y1: 67.93,
    x2: 92.23,
    y2: 20.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4d67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff665a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_43-2",
    x1: 137.59,
    y1: 68.81,
    x2: 137.59,
    y2: 21.71,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_43-3",
    x1: 183.09,
    y1: 68.81,
    x2: 183.09,
    y2: 10.36,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_43-4",
    x1: 225.3,
    y1: 68.68,
    x2: 225.3,
    y2: 21.84,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_43-5",
    x1: 34.14,
    y1: 68.55,
    x2: 34.14,
    y2: 0,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_43-6",
    x1: 45.57,
    y1: 53.53,
    x2: 45.57,
    y2: 37.98,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_43-7",
    x1: 61.92,
    y1: 70,
    x2: 61.92,
    y2: 54.35,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_43"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1-2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.91,20.84A20.32,20.32,0,0,0,88,26.34V21.71H77.12V67.93H88.44V43c0-5.74,4.24-11.55,12.37-11.55a24.49,24.49,0,0,1,5,.32l1.54.32V21.26l-1.11-.15A34.41,34.41,0,0,0,101.91,20.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M149.22,46.31c0,5.95-4.09,12-11.91,12C130.52,58.29,126,53.76,126,47V21.71H114.64V47.18c0,13.34,8.08,21.63,21.1,21.63a20,20,0,0,0,13.94-5.68v4.8h10.86V21.71H149.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M181.36,10.36H170.05V53.9c0,9.89,6.75,14.91,17.33,14.91,5.65,0,8.76-1.88,8.76-1.88V56.79a19.23,19.23,0,0,1-8.3,1.59c-5.2,0-6.48-3.17-6.48-6.94V32.14h12V21.71h-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M225.39,21.84c-13.9,0-24.79,10.29-24.79,23.42s10.89,23.42,24.79,23.42S250,58.39,250,45.26,239.19,21.84,225.39,21.84Zm14,23.42c0,7.83-6,13.73-14,13.73s-14.21-5.9-14.21-13.73,6.11-13.73,14.21-13.73S239.42,37.43,239.42,45.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M34.14,56.75A22.47,22.47,0,1,1,53.32,45.84l8.48,8.51a34.13,34.13,0,1,0-7.67,7.7l-8.48-8.52A22.11,22.11,0,0,1,34.14,56.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M37.83,45.68l7.82,7.85a22.49,22.49,0,0,0,7.67-7.69L45.49,38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M69.72,62.3,61.8,54.35a34.38,34.38,0,0,1-7.67,7.7l7.92,8Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c5c3a20d3de4e6e3f7fb09774d7c1619.svg";
export { ForwardRef as ReactComponent };